webpackJsonp([2],{

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(159);

var _components = __webpack_require__(752);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = function Home() {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        "title",
        null,
        " Home - afrodesiamedia "
      ),
      _react2.default.createElement("link", { rel: "shortcut icon", href: "/favicon.ico" }),
      _react2.default.createElement("meta", { property: "og:type", content: "company" }),
      _react2.default.createElement("meta", { property: "og:url", content: "https://www.afrodesiamedia.com/" }),
      _react2.default.createElement("meta", { property: "og:image", content: "http://afrodesiamedia.com/afrodesiamedia-meta-screen.jpg" }),
      _react2.default.createElement("meta", { property: "og:title", content: "Home" })
    ),
    _react2.default.createElement(_components.HomePage, null)
  );
};

exports.default = Home;

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CenterHead = exports.Preamble = exports.MastHead = exports.HomePage = undefined;

var _HomePage = __webpack_require__(755);

var _HomePage2 = _interopRequireDefault(_HomePage);

var _masthead = __webpack_require__(756);

var _masthead2 = _interopRequireDefault(_masthead);

var _preamble = __webpack_require__(757);

var _preamble2 = _interopRequireDefault(_preamble);

var _centerhead = __webpack_require__(761);

var _centerhead2 = _interopRequireDefault(_centerhead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.HomePage = _HomePage2.default;
exports.MastHead = _masthead2.default;
exports.Preamble = _preamble2.default;
exports.CenterHead = _centerhead2.default;

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ = __webpack_require__(752);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ScrollAnimation from 'react-animate-on-scroll'

var HomePage = function (_Component) {
  _inherits(HomePage, _Component);

  function HomePage() {
    _classCallCheck(this, HomePage);

    return _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).apply(this, arguments));
  }

  _createClass(HomePage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'Home' },
          _react2.default.createElement(_.MastHead, null),
          _react2.default.createElement(_.CenterHead, null),
          _react2.default.createElement(_.Preamble, null)
        )
      );
    }
  }]);

  return HomePage;
}(_react.Component);

exports.default = HomePage;

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Masthead = function Masthead() {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "section",
      { className: "Masthead" },
      _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(
          "div",
          { className: "row center-xs" },
          _react2.default.createElement(
            "div",
            { className: "col-xs-10 Hero" },
            _react2.default.createElement(
              "div",
              { className: "box" },
              _react2.default.createElement(
                "h1",
                { className: "slide-right" },
                "We create unique things for your visual needs!"
              ),
              _react2.default.createElement(
                "h2",
                { className: "slide-left" },
                "Discover what good design and practical sense makes for a better user experience."
              ),
              _react2.default.createElement(
                "div",
                { className: "button-wrap slide-up" },
                _react2.default.createElement(
                  _reactStatic.Link,
                  { to: "/getting-started", className: "getting-started" },
                  _react2.default.createElement("i", { className: "fa fa-thumbs-up", "aria-hidden": "true" }),
                  "start your project today!"
                )
              )
            )
          )
        )
      )
    )
  );
};
// import ScrollAnimation from 'react-animate-on-scroll'
exports.default = Masthead;

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _clipboard = __webpack_require__(758);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _Pen = __webpack_require__(759);

var _Pen2 = _interopRequireDefault(_Pen);

var _Tablet = __webpack_require__(760);

var _Tablet2 = _interopRequireDefault(_Tablet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Preamble = function Preamble() {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "section",
      { className: "Preamble" },
      _react2.default.createElement(
        "div",
        { className: "grey-zone" },
        _react2.default.createElement(
          "div",
          { className: "container " },
          _react2.default.createElement(
            "div",
            { className: "grey-list" },
            _react2.default.createElement(
              "div",
              { className: "box" },
              _react2.default.createElement(
                "article",
                { className: "greyblock" },
                _react2.default.createElement(
                  "div",
                  { className: "icon" },
                  " ",
                  _react2.default.createElement("img", { className: "img clip", src: _clipboard2.default, width: "100" }),
                  " "
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  " ",
                  "Good design is crafting the User experience in simple path to push them to the things that matters most for your website.",
                  " "
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "box" },
              _react2.default.createElement(
                "article",
                { className: "greyblock" },
                _react2.default.createElement(
                  "div",
                  { className: "icon" },
                  " ",
                  _react2.default.createElement("img", { className: "img", src: _Pen2.default, width: "24" }),
                  " "
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  " ",
                  "Good content enhances the direction you want to prioritize for your consumers to flow thru the website experience.",
                  " "
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "box" },
              _react2.default.createElement(
                "article",
                { className: "greyblock" },
                _react2.default.createElement(
                  "div",
                  { className: "icon" },
                  " ",
                  _react2.default.createElement("img", { className: "img", src: _Tablet2.default, width: "48" }),
                  " "
                ),
                _react2.default.createElement(
                  "p",
                  null,
                  " ",
                  "There are things that good design can clear up and implement; are good visual communication and heigharchy.",
                  " "
                )
              )
            )
          )
        )
      )
    )
  );
};
// import ScrollAnimation from 'react-animate-on-scroll'

exports.default = Preamble;

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNzYiIGhlaWdodD0iMTMwIiB2aWV3Qm94PSIwIDAgNzYgMTMwIj4KICA8ZGVmcz4KICAgIDxwb2x5Z29uIGlkPSJjbGlwYm9hcmQtYSIgcG9pbnRzPSI3NS4xMTggMTI5LjQ0IDc1LjExOCAuMDY5IDAgLjA2OSAwIDEyOS40NCA3NS4xMTggMTI5LjQ0Ii8+CiAgICA8cG9seWdvbiBpZD0iY2xpcGJvYXJkLWMiIHBvaW50cz0iMCAxMjkuNjUgNzUuMTE4IDEyOS42NSA3NS4xMTggLjI3OSAwIC4yNzkiLz4KICA8L2RlZnM+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSguMjUgLjE5KSI+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC4yMSkiPgogICAgICA8bWFzayBpZD0iY2xpcGJvYXJkLWIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2NsaXBib2FyZC1hIi8+CiAgICAgIDwvbWFzaz4KICAgICAgPHBhdGggZmlsbD0iIzAwMCIgZD0iTTQuODU3MDc1LDIwLjAzNjQ0OSBMMjcuMTQ2NywyMC4wMzY0NDkgTDI3LjQxMjIsMjEuNTQ5MzAxNCBDMjcuNTQ2MDc1LDIyLjMwNTA4ODIgMjguMTEwODI1LDIyLjgzNDUyMjYgMjguODA5NDUsMjIuODM0NTIyNiBMNDYuNTA3OTUsMjIuODM0NTIyNiBDNDcuMTczOTUsMjIuODM0NTIyNiA0Ny43NzI0NSwyMi4zMDUwODgyIDQ3LjkwNTIsMjEuNTQ5MzAxNCBMNDguMTcxODI1LDIwLjAzNjQ0OSBMNzAuNDYxNDUsMjAuMDM2NDQ5IEw3MC40NjE0NSwxMjQuMDcwMzA3IEw0Ljg1NzA3NSwxMjQuMDcwMzA3IEw0Ljg1NzA3NSwyMC4wMzY0NDkgWiBNMzcuNjI2MDc1LDIuNzU0MzgwNDIgQzM4LjU1NzU3NSwyLjc1NDM4MDQyIDM5LjM1NjMyNSwzLjYyMzk4MjggMzkuMzU2MzI1LDQuNzIxMjE2NCBDMzkuMzU2MzI1LDUuNzgwMDg1MTkgMzguNTkwMiw2LjY4Njc3MzU2IDM3LjYyNjA3NSw2LjY4Njc3MzU2IEMzNi42NjA4MjUsNi42ODY3NzM1NiAzNS44OTU4MjUsNS44MTcxNzExNyAzNS44OTU4MjUsNC43MjEyMTY0IEMzNS45Mjk1NzUsMy42MjM5ODI4IDM2LjY5NDU3NSwyLjc1NDM4MDQyIDM3LjYyNjA3NSwyLjc1NDM4MDQyIEwzNy42MjYwNzUsMi43NTQzODA0MiBaIE0yLjIyOTA3NSwxMjkuNDQwMTAyIEw3Mi45ODkzMjUsMTI5LjQ0MDEwMiBDNzQuMTUzNywxMjkuNDQwMTAyIDc1LjExODk1LDEyOC4zODEyMzMgNzUuMTE4OTUsMTI3LjAyMDU2MSBMNzUuMTE4OTUsMTcuMDg2MTk1IEM3NS4xMTg5NSwxNS43NjI2MDkgNzQuMTg3NDUsMTQuNjY2NjU0MyA3Mi45ODkzMjUsMTQuNjY2NjU0MyBMNDkuMDAzMiwxNC42NjY2NTQzIEw0OS4zNjk5NSwxMi40MzUxMDExIEM0OS41MzUzMjUsMTEuNDUxNjgzMSA0OC44NzA0NSwxMC41MDY2Mjk5IDQ3Ljk3MjcsMTAuNTA2NjI5OSBMNDEuMjg1NywxMC41MDY2Mjk5IEw0MS4yODU3LDQuMzA0MzE4NzkgQzQxLjI4NTcsMS45NjAyMjg4MyAzOS42MjE4MjUsMC4wNjg4NDM2MzgyIDM3LjU1OTcsMC4wNjg4NDM2MzgyIEMzNS40OTY0NSwwLjA2ODg0MzYzODIgMzMuODMzNywxLjk2MDIyODgzIDMzLjgzMzcsNC4zMDQzMTg3OSBMMzMuODMzNywxMC41MDY2Mjk5IEwyNy4xNDY3LDEwLjUwNjYyOTkgQzI2LjI0NzgyNSwxMC41MDY2Mjk5IDI1LjU4Mjk1LDExLjQxNDU5NzEgMjUuNzQ5NDUsMTIuNDM1MTAxMSBMMjYuMTE1MDc1LDE0LjY2NjY1NDMgTDIuMTI4OTUsMTQuNjY2NjU0MyBDMC45NjQ1NzUsMTQuNjY2NjU0MyAwLjAwMDQ1LDE1LjcyNTUyMzEgMC4wMDA0NSwxNy4wODYxOTUgTDAuMDAwNDUsMTI3LjAyMDU2MSBDMC4xMzMyLDEyOC4zNDQxNDcgMS4wNjQ3LDEyOS40NDAxMDIgMi4yMjkwNzUsMTI5LjQ0MDEwMiBMMi4yMjkwNzUsMTI5LjQ0MDEwMiBaIiBtYXNrPSJ1cmwoI2NsaXBib2FyZC1iKSIvPgogICAgPC9nPgogICAgPG1hc2sgaWQ9ImNsaXBib2FyZC1kIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjY2xpcGJvYXJkLWMiLz4KICAgIDwvbWFzaz4KICAgIDxwb2x5Z29uIGZpbGw9IiMwMDAiIHBvaW50cz0iMjQuMDg2IDQxLjE5NyA2NC4zNCA0MS4xOTcgNjQuMzQgMzguNDM2IDI0LjA4NiAzOC40MzYiIG1hc2s9InVybCgjY2xpcGJvYXJkLWQpIi8+CiAgICA8cG9seWdvbiBmaWxsPSIjMDAwIiBwb2ludHM9IjE1LjEwNCAzOS4yNjggMTIuNjc1IDM2LjU0NSAxMC45MTIgMzguNTg4IDE1LjEwNCA0My4zMTQgMjMuNDIxIDMzLjg2IDIxLjYyNCAzMS44NTYiIG1hc2s9InVybCgjY2xpcGJvYXJkLWQpIi8+CiAgICA8cG9seWdvbiBmaWxsPSIjMDAwIiBwb2ludHM9IjI0LjA4NiA1NSA2NC4zNCA1NSA2NC4zNCA1Mi4yMzkgMjQuMDg2IDUyLjIzOSIgbWFzaz0idXJsKCNjbGlwYm9hcmQtZCkiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiMwMDAiIHBvaW50cz0iMTUuMTA0IDUzLjEwOSAxMi42NzUgNTAuMzg2IDEwLjkxMiA1Mi4zOSAxNS4xMDQgNTcuMTU1IDIzLjQyMSA0Ny43MDEgMjEuNjI0IDQ1LjY1OSIgbWFzaz0idXJsKCNjbGlwYm9hcmQtZCkiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiMwMDAiIHBvaW50cz0iMjQuMDg2IDY4Ljg0MSA2NC4zNCA2OC44NDEgNjQuMzQgNjYuMDggMjQuMDg2IDY2LjA4IiBtYXNrPSJ1cmwoI2NsaXBib2FyZC1kKSIvPgogICAgPHBvbHlnb24gZmlsbD0iIzAwMCIgcG9pbnRzPSIxNS4xMDQgNjYuOTUgMTIuNjc1IDY0LjE4OSAxMC45MTIgNjYuMjMxIDE1LjEwNCA3MC45NTkgMjMuNDIxIDYxLjUwNSAyMS42MjQgNTkuNSIgbWFzaz0idXJsKCNjbGlwYm9hcmQtZCkiLz4KICAgIDxwb2x5Z29uIGZpbGw9IiMwMDAiIHBvaW50cz0iMjQuMDg2IDgyLjY0NCA2NC4zNCA4Mi42NDQgNjQuMzQgNzkuODgzIDI0LjA4NiA3OS44ODMiIG1hc2s9InVybCgjY2xpcGJvYXJkLWQpIi8+CiAgICA8cG9seWdvbiBmaWxsPSIjMDAwIiBwb2ludHM9IjE1LjEwNCA4MC43NTMgMTIuNjc1IDc4LjAzIDEwLjkxMiA4MC4wMzQgMTUuMTA0IDg0Ljc5OSAyMy40MjEgNzUuMzQ1IDIxLjYyNCA3My4zMDMiIG1hc2s9InVybCgjY2xpcGJvYXJkLWQpIi8+CiAgICA8cG9seWdvbiBmaWxsPSIjMDAwIiBwb2ludHM9IjI0LjA4NiA5Ni40ODUgNjQuMzQgOTYuNDg1IDY0LjM0IDkzLjcyNCAyNC4wODYgOTMuNzI0IiBtYXNrPSJ1cmwoI2NsaXBib2FyZC1kKSIvPgogICAgPHBvbHlnb24gZmlsbD0iIzAwMCIgcG9pbnRzPSIxNS4xMDQgOTQuNTk0IDEyLjY3NSA5MS44MzMgMTAuOTEyIDkzLjg3NSAxNS4xMDQgOTguNjQgMjMuNDIxIDg5LjE0OSAyMS42MjQgODcuMTQ0IiBtYXNrPSJ1cmwoI2NsaXBib2FyZC1kKSIvPgogICAgPHBvbHlnb24gZmlsbD0iIzAwMCIgcG9pbnRzPSIyNC4wODYgMTEwLjI4OSA2NC4zNCAxMTAuMjg5IDY0LjM0IDEwNy41MjggMjQuMDg2IDEwNy41MjgiIG1hc2s9InVybCgjY2xpcGJvYXJkLWQpIi8+CiAgICA8cG9seWdvbiBmaWxsPSIjMDAwIiBwb2ludHM9IjE1LjEwNCAxMDguMzk3IDEyLjY3NSAxMDUuNjc1IDEwLjkxMiAxMDcuNjc4IDE1LjEwNCAxMTIuNDQzIDIzLjQyMSAxMDIuOTg5IDIxLjYyNCAxMDAuOTg1IiBtYXNrPSJ1cmwoI2NsaXBib2FyZC1kKSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 759:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzEiIGhlaWdodD0iMTM1IiB2aWV3Qm94PSIwIDAgMzEgMTM1Ij4KICA8ZGVmcz4KICAgIDxwb2x5Z29uIGlkPSJwZW4tYSIgcG9pbnRzPSIwIDEzNi42MzIgMjkuNzc0IDEzNi42MzIgMjkuNzc0IDAgMCAwIi8+CiAgPC9kZWZzPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjI1IC0xLjg1OCkiPgogICAgPHBhdGggZmlsbD0iIzAwMCIgZD0iTTExLjcxMDIzNzUsMi41NTgxNjU2MSBDMTguMTk2OTg3NSwyLjU1ODE2NTYxIDIzLjQyMDM2MjUsOC40OTU3NTk1NCAyMy4zODc3Mzc1LDE1LjgzMjM5MDMgTDIzLjM4NzczNzUsNjEuODE2NDUyOSBMMC4wMDAxMTI1LDYxLjgxNjQ1MjkgTDAuMDAwMTEyNSwxNS44Njk0NzYyIEMwLjAwMDExMjUsOC40OTU3NTk1NCA1LjI1NjExMjUsMi41NTgxNjU2MSAxMS43MTAyMzc1LDIuNTU4MTY1NjEgWiIvPgogICAgPG1hc2sgaWQ9InBlbi1iIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjcGVuLWEiLz4KICAgIDwvbWFzaz4KICAgIDxwb2x5Z29uIGZpbGw9IiMwMDAiIHBvaW50cz0iMi42MjggMTIzLjA0MiAyMS4yNTggMTIzLjA0MiAyMS4yNTggNjMuNzg0IDIuNjI4IDYzLjc4NCIgbWFzaz0idXJsKCNwZW4tYikiLz4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0xMC4xNzk5IDEzNS4zNzA2MkwxMC42MTE5IDEzNS4zNzA2MiAxMC45MTIyNzUgMTM4LjAxNzc5MkMxMC45Nzg2NSAxMzguNjk4MTI4IDExLjQ0NDQgMTM5LjE5MDQ3NiAxMS45NDI3NzUgMTM5LjE5MDQ3NiAxMi40NDIyNzUgMTM5LjE5MDQ3NiAxMi45MDgwMjUgMTM4LjY5ODEyOCAxMi45NzQ0IDEzOC4wMTc3OTJMMTMuMjczNjUgMTM1LjM3MDYyIDEzLjcwNjc3NSAxMzUuMzcwNjIgMjAuMDkzNCAxMjUuMDA4Mjg0IDMuODI1OSAxMjUuMDA4Mjg0IDEwLjE3OTkgMTM1LjM3MDYyek0yNS4xODM4IDE5LjMxMTA1NTZMMjUuMTgzOCA2MS43Nzk2MjI3QzI3LjcxMTY3NSA2MS43Nzk2MjI3IDI5Ljc3NDkyNSA1OS40MzQyNTM5IDI5Ljc3NDkyNSA1Ni41NjA3Mjk1TDI5Ljc3NDkyNSAyNC41Mjk5NDg3QzI5Ljc3NDkyNSAyMS42NTUxNDU1IDI3LjcxMTY3NSAxOS4zMTEwNTU2IDI1LjE4MzggMTkuMzExMDU1NiIgbWFzaz0idXJsKCNwZW4tYikiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2OSIgaGVpZ2h0PSIxMzMiIHZpZXdCb3g9IjAgMCA2OSAxMzMiPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTExMjguNjM3ODIsMTU3OS42OTg2NCBMMTE4NC45MTE4NCwxNTc5LjY5ODY0IEwxMTg0LjkxMTg0LDE0NzIuODEwODggTDExMjguNjM3ODIsMTQ3Mi44MTA4OCBMMTEyOC42Mzc4MiwxNTc5LjY5ODY0IFogTTExNTkuNDgzNTcsMTU5Mi44NDE3IEwxMTU0LjA2NDY0LDE1OTIuODQxNyBDMTE1MS45MzIyOCwxNTkyLjg0MTcgMTE1MC4yMjU1MiwxNTkwLjkwMTU2IDExNTAuMjI1NTIsMTU4OC40Nzc2MyBDMTE1MC4yMjU1MiwxNTg2LjA1MjA1IDExNTEuOTMyMjgsMTU4NC4xMTE5MiAxMTU0LjA2NDY0LDE1ODQuMTExOTIgTDExNTkuNTI2ODUsMTU4NC4xMTE5MiBDMTE2MS42NTkyMiwxNTg0LjExMTkyIDExNjMuMzY1OTgsMTU4Ni4wNTIwNSAxMTYzLjM2NTk4LDE1ODguNDc3NjMgQzExNjMuMzIyNywxNTkwLjg1NCAxMTYxLjYxNzM4LDE1OTIuODQxNyAxMTU5LjQ4MzU3LDE1OTIuODQxNyBMMTE1OS40ODM1NywxNTkyLjg0MTcgWiBNMTEyNi4zNzcwNSwxNTk3LjI1NDk3IEwxMTg3LjE3MjYxLDE1OTcuMjU0OTcgQzExODkuMTc4MDIsMTU5Ny4yNTQ5NyAxMTkwLjc5ODIxLDE1OTUuNDExNiAxMTkwLjc5ODIxLDE1OTMuMTMxOTggTDExOTAuNzk4MjEsMTQ2OS42NTg3NyBDMTE5MC43OTgyMSwxNDY3LjM3OTE2IDExODkuMTc4MDIsMTQ2NS41MzU3OSAxMTg3LjE3MjYxLDE0NjUuNTM1NzkgTDExMjYuMzc3MDUsMTQ2NS41MzU3OSBDMTEyNC4zNzE2NCwxNDY1LjUzNTc5IDExMjIuNzUsMTQ2Ny4zNzkxNiAxMTIyLjc1LDE0NjkuNjU4NzcgTDExMjIuNzUsMTU5My4wODQ0MiBDMTEyMi43NSwxNTk1LjM2NDA0IDExMjQuMzcxNjQsMTU5Ny4yNTQ5NyAxMTI2LjM3NzA1LDE1OTcuMjU0OTcgTDExMjYuMzc3MDUsMTU5Ny4yNTQ5NyBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEyMiAtMTQ2NSkiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CenterHead = function CenterHead() {
  return _react2.default.createElement(
    "section",
    { className: "Centerhead" },
    _react2.default.createElement(
      "div",
      { className: "container" },
      _react2.default.createElement(
        "div",
        { className: "row center-xs" },
        _react2.default.createElement(
          "div",
          { className: "col-xs-5" },
          _react2.default.createElement(
            "div",
            { className: "box" },
            _react2.default.createElement(
              "h2",
              { className: "" },
              "Crafting results to communicate your design needs"
            )
          )
        )
      )
    )
  );
};

exports.default = CenterHead;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Home/Home.c4b576bf.js